import { IApplicationState } from '../../types/redux';

export const selectBuilderId = (state: IApplicationState): number => {
  return state.builderCard.id;
};
